/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path  判断字符串是否是https?:|mailto:|tal: 开头的
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str  //检验字符串是否是 admin  editor
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}


/**
 * @param {string} str  判断都是大写字母
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str  验证香港的座机号(以数字2,3,5,6,9开头，共八个数字)
 * @returns {Boolean}
 */
export function validHKTel(str) {

  // const reg =  /^[23569]\d{7}$/ || /^(00)?852\d{8}$/ || /^(852)\d{11}$/;
  let str2 =str.replace(/\s+/g,"");
  //  (^00852[23569]{1}\d{7}$)
  const reg =  /(^[23456789]\d{7}$)|(^(00)?852[23456789]{1}\d{7}$)|(^852[23456789]{1}[0-9]{7}$)|(^\+852[23456789]{1}[0-9]{7}$)/
  // console.log('是否匹配',reg.test(str2))
  return reg.test(str2)
}

/**
 * @param {string} str  判断是否是字母
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}
export function    has(arr,n){

  var flag=false

     //遍历
      for (var j=0;j<arr.length;j++) {
    //判断有没有这个数据
     if(arr[j].Location_Code==n){
       flag=true
      }
      }
    return flag

}

/**
 * @param {string} str 判断是否字符串
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}
/**
 * @param {string} str_url 驗證url的合法性
 * @returns {Boolean}
 */
// var reg = /^(?:(?:ftp|https?):\/\/)?(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?\.)+(?:com|edu|biz|org|gov|int|info|mil|net|name|museum|coop|aero|[a-z][a-z])\b(?:\d+)?(?:\/[^;"'&lt;&gt;()\[\]{}\s\x7f-\xff]*(?:[.,?]+[^;"'&lt;&gt;()\[\]{}\s\x7f-\xff]+)*)?/
// var reg=/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&‘\*\+,;=.]+$/;
export function IsURL(str_url){ 
    var strRegex = "^((https|http|ftp|rtsp|mms)?://)"  
    + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@  
    + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184  
    + "|" // 允许IP和DOMAIN（域名） 
    + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.  
    + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名  
    + "[a-z]{2,6})" // first level domain- .com or .museum  
    + "(:[0-9]{1,4})?" // 端口- :80  
    + "((/?)|" // a slash isn't required if there is no file name  
    + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";  
    var re=new RegExp(strRegex);  
    if (re.test(str_url)){ 
        return (true);  
    }else{  
        return (false);  
    } 
}

/**
 * @param {Array} arg  判断是否是数组
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}
/**
 * @param {val} arg  年月日轉換
 * @returns  2020年10月22日
 */
export function formatDayTime(val) {
  if (val) {
    let date = new Date(val);
    console.log('date: ', date);
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    if (M < 10) {
      M = "0" + M;
    }
    if (D < 10) {
      D = "0" + D;
    }
    return Y + "年" + M + "月" + D+"日";
  } else {
    return "";
  }
}
/**
 * @param {val} arg  獲取當前時間格式為yy-mm-dd
 * @returns
 */
export function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
/**
 * @param {val} arg  時間戳轉化為年月日時分秒
 * @returns
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

/**
 * @param {date1} string  當前日期和另一個日期對比
 * @returns
 */
//比较两个日期的大小
export function compareDate(data,date1) {
  let oDate1 = new Date(date1);
  let oDate = new Date(data);
  if ( oDate.getTime() == oDate1.getTime() ) {
    return '等於';
  } else if( oDate.getTime() > oDate1.getTime()){
    return '大於';
  }else {
    return '小於';
  }
}
/**
 * @param {str}   當前值
 * @returns
 */
// 判斷客戶原運單是否漢字
export function  existChinese(str) {
  var regExp = new RegExp('[\u4E00-\u9FA5\uFE30-\uFFA0]');
  if (regExp.test(str)) {
    return true;
  } else {
    return false;
  }
}
/**
 * @param {num}   當前值
 * @returns
 */
// 只能输入数字和一个小数点的正则表达式  var reg = /^\d+$|^\d*\.\d+$/g;
// 驗證是否為只有一個小數點的數字
export function validateNum(num){
  var reg = /^\d+(?=\.{0,1}\d+$|$)/
  if(reg.test(num)) return true;
  return false ;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}


